import { useRef } from "react";
import { Helmet } from "react-helmet";

import { EarnSection, FeesSection, StepsSection, ThesisSection } from "./components/ContentSections";
import { FaqSection, LandingFooter } from "./components/FaqAndFooter";
import { HeroSection } from "./components/HeroSection";
import { LandingHeader } from "./components/LandingHeader";
// import { MarketChartSection } from "./components/MarketChartSection";
import { RoutingSection } from "./components/RoutingSection";
import { TerminalSection } from "./components/TerminalSection";
import { TickerTape } from "./components/TickerTape";
import { useReveal } from "./useReveal";

import "./landing.css";

/**
 * USDX marketing landing page, served at `/`.
 *
 * The navbar links, the logo lockup and every footer link are inert while the
 * site is gated — they hold their place in the layout but navigate nowhere. The
 * "Launch App" CTAs and the earn CTA still route to `APP_ENTRY_ROUTE`.
 *
 * `MarketChartSection` (the TradingView Advanced Chart) is commented out below
 * rather than deleted; the component and its `CHART_SYMBOLS` config are intact.
 *
 * Note: every figure on this page is placeholder marketing copy. See the
 * warning at the top of `landingContent.ts` before publishing.
 */
export default function Landing() {
  const rootRef = useRef<HTMLDivElement>(null);
  useReveal(rootRef);

  return (
    <>
      <Helmet>
        <title>USDX | Decentralized Perpetual Exchange</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Plus+Jakarta+Sans:wght@600;700;800&family=JetBrains+Mono:wght@400;500;600&display=swap"
        />
        {/* Anchor nav relies on smooth scrolling; scoped to this route. */}
        <style>{"html{scroll-behavior:smooth}"}</style>
      </Helmet>

      <div className="usdx-landing" ref={rootRef}>
        <LandingHeader />
        <HeroSection />
        {/* <MarketChartSection /> */}
        <TickerTape />
        <RoutingSection />
        <TerminalSection />
        <ThesisSection />
        <StepsSection />
        <FeesSection />
        <EarnSection />
        <FaqSection />
        <LandingFooter />
      </div>
    </>
  );
}
